import React from "react";
import { Carousel } from "@mantine/carousel";
import { createStyles } from "@mantine/core";
import { ArrowLeft, ArrowRight } from "../Svg";

const useStyles = createStyles((theme) => ({
  root: {
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      bottom: -28,
      left: -34,
      width: "191px",
      height: "180px",
      backgroundImage: `url(/images/square-texture.png)`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPositionX: "left",
      zIndex: 0,
    },
  },
  viewport: {
    height: "100%",
  },
  controls: {
    justifyContent: "flex-end",
    top: "-100px",
    maxWidth: "1180px",
    marginRight: "auto",
  },
  control: {
    boxShadow: "none",
    border: "transparent",
    color: theme.colors.primary,
    backgroundColor: theme.colors.primaryOpacity,
    "&:first-child": {
      borderRadius: "6px 0 0 6px",
      padding: "13px 8px 13px 18px",
    },
    "&:nth-child(2)": {
      borderRadius: "0 6px 6px 0",
      padding: "13px 18px 13px 8px",
    },
    "@media (max-width: 610px)": {
      display: "none",
    },
  },
  indicators: {
    bottom: "-50px",
    maxWidth: "1180px",
    marginRight: "auto",
  },

  indicator: {
    backgroundColor: theme.colors.primary,
    width: "12px",
    height: "12px",
  },
}));

export default function CSlider({ items }) {
  const { classes } = useStyles();

  return (
    <Carousel
      classNames={{
        root: classes.root,
        controls: classes.controls,
        control: classes.control,
        indicators: classes.indicators,
        indicator: classes.indicator,
        viewport: classes.viewport,
      }}
      previousControlIcon={<ArrowLeft />}
      nextControlIcon={<ArrowRight />}
      previousControlLabel="Previous"
      nextControlLabel="Next"
      slideSize="20%"
      slideGap="md"
      withIndicators
      dragFree={true}
      loop={true}
      align="start"
      breakpoints={[
        { maxWidth: "lg", slideSize: "30%" },
        { maxWidth: "md", slideSize: "40%" },
        { maxWidth: "sm", slideSize: "100%" },
        { maxWidth: "xs", slideSize: "100%" },
      ]}
    >
      {items.map((item) => (
        <Carousel.Slide key={item.id}>{item.component}</Carousel.Slide>
      ))}
    </Carousel>
  );
}
